(function() {
    'use strict';
    a3_cabin_reports.directive('groundServices', groundServices);

/**
   * @memberof CabinReports
   * @ngdoc directive
   * @name groundServices
   * @restrict E
   * @description
   *   Implementation of ground services 
   *
   *   Display the ground services
   * @attr {String} arrival The flight arrival station.
   * @attr {String} departure The flight departure station.
   * @attr {String} flight-id The flight id.
   * @example
   *   Usage:
   *   <ground-services arrival="ATH" departure="MAD" flight-id="123"></ground-services>
   *   
   * @ngInject
   */    
function groundServices(GroundServicesFactory, CabinReportLocalEditFactory, CabinReportLocalEditCreatorFactory, FlightFactory, $sce) {

    /**
     * Initialize groundServices
     * @memberof groundServices
     * @param {service} scope the scope of this element
     * @param {service} element element that this direcive is assigned to
     * @param {service} attributes attributes of this element
     */
    function link(scope, element, attributes){
        scope.togglePanel = togglePanel;
        scope.flight = FlightFactory.getFlightFromTotalFlights(scope.flightId);
        scope.isInFinalState = isInFinalState;
        scope.saveNewUsedState = saveNewUsedState;
        scope.DepartureGroundServices = [];
        scope.ArrivalGroundServices = [];
        scope.popoverInfo = {
            title: $sce.trustAsHtml(' Info'),
            contentHtml: $sce.trustAsHtml('<div style="width:210px;"><span class="text-blue"><i class="fa fa-square"></i></span> Contracted Services' + 
            '<br /><span class="text-gray"><i class="fa fa-square"></i></span> Non Contracted Services' +
            '<div/>')
          };
        var report = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(scope.flightId);

        if (report == null){
            if (scope.departure){
                scope.DepartureGroundServices = GroundServicesFactory.getGroundServicesByStation(scope.departure);
            }
            // if (scope.arrival){
            //     scope.ArrivalGroundServices = GroundServicesFactory.getGroundServicesByStation(scope.arrival);
            // }
        }
        else {
            report = CabinReportLocalEditFactory.checkForNewGroundServices(report);
            if (scope.departure){
                scope.DepartureGroundServices = report.DepartureGroundServices;
            }
            // if (scope.arrival){
            //     scope.ArrivalGroundServices = report.ArrivalGroundServices;
            // }
        }


        /**
         * Check if the report is in a final state so that we cant edit any more
         * @memberof groundServices
         * @returns {boolean} true if final, false otherwise
         */
        function isInFinalState(){
           var isInFinalState = ((scope.flight.LineStatus === 'na') ||
                (scope.flight.LineStatus === 'stored') ||
                (scope.flight.LineStatus === 'storedotheruser') ||
                (scope.flight.LineStatus === 'stored+otheruser') ||
                (scope.flight.LineStatus === 'synched') ||
                (scope.flight.LineStatus === 'synchedotheruser'));
            return isInFinalState;
        }

        /**
         * When a ground service usage is toggled on or off,
         * create the report if it doesnt exist
         * or just save the changes
         * @memberof groundServices
         */
        function saveNewUsedState() {
            //if report is pending, it doesnt exist yet. create it
            if (scope.flight.LineStatus === 'pending' || scope.flight.LineStatus === 'pendingoverdue'){
                report = CabinReportLocalEditCreatorFactory.createNewLocalReportForFlight(scope.flightId);  
                if (scope.departure){
                    report.DepartureGroundServices = scope.DepartureGroundServices;
                }else{
                    report.DepartureGroundServices=[];
                }
                // if (scope.arrival){
                //     report.ArrivalGroundServices = scope.ArrivalGroundServices;
                // }else{
                //     report.ArrivalGroundServices = [];
                // }
                report.Status = 'draft';
                report.saveReport();
                FlightFactory.updateFlightFromReport(report);
            }

            CabinReportLocalEditFactory.setCabinReportToStorage(report);
        }

        //TODO : find a more angular way (EPAP)
        /**
         * toggle Panel
         * @memberof groundServices
         * @param {number} panelId
         */
        function togglePanel(panelId) {
            $('#' + panelId).toggle();
        }
    }
    
    return {
			restrict: 'E',
			terminal: true,
			templateUrl: 'views/directives/groundServices.tpl.html',
			scope: {
                arrival: '@',
                departure: '@',
                flightId: '@'
            },
            link: link
    }
}

})();